import { Text, View } from "@react-pdf/renderer";
import React, { Fragment } from "react";
import { BorderColor, TableRowStyle } from "../../../styles";
import {
  invoiceRowCss,
  rowBalanceText
} from "../../../utils/Level/utils";

const borderColor = BorderColor;

const styles = TableRowStyle;

const InvoiceTableRow = ({ items, openingBalance }) => {
  const rows = items.map((item) => (
    <View style={invoiceRowCss} key={item.vouher_no}>
      <Text style={styles.voucher}>{item.vouher_no}</Text>
      <Text style={styles.date}>{item.date}</Text>
      <Text style={styles.type}>{item.type}</Text>
      <Text style={styles.particulars}>{item.desc}</Text>
      <Text style={styles.cheque}>
        {item.bill_no.toLocaleString() === ""
          ? "-"
          : item.bill_no.toLocaleString()}
      </Text>
      <Text style={rowBalanceText}>{item.debit}</Text>
      <Text style={rowBalanceText}>{item.credit}</Text>
      <Text style={rowBalanceText}>{item.balance}</Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;

export const VoucherTableRow = ({ items }) => {
  const rows = items.map((item, index) => (
    <View style={styles.invoiceRowCss} key={index}>
      <Text style={styles.date}>{item.code}</Text>
      <Text style={styles.particulars}>{item.particular}</Text>
      <Text style={styles.particulars}>{item.description}</Text>
      <Text style={styles.cheque}>
        {item.cheque.toLocaleString() === ""
          ? "-"
          : item.cheque.toLocaleString()}
      </Text>
      <Text style={rowBalanceText}>
        {item.debit.toLocaleString() === "" ? "-" : item.debit.toLocaleString()}
      </Text>
      <Text style={rowBalanceText}>
        {item.credit.toLocaleString() === ""
          ? "-"
          : item.credit.toLocaleString()}
      </Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

const Level3Row = ({ arr }) => {
  console.log(arr);

  return arr.map((item, index) => (
    <View style={styles.invoiceRowCss} key={index}>
      <Text style={styles.trialLevel3}>{item.fullcode}</Text>
      <Text style={styles.trialparticulars}>{item.Discription}</Text>
      <Text style={styles.trialcredit}>
        {item.amount >= 0 ? item.amount.toLocaleString() : "0"}
      </Text>
      <Text style={styles.trialcredit}>
        {item.amount >= 0 ? "0" : Math.abs(item.amount).toLocaleString()}
      </Text>
    </View>
  ));
};

const Level2Row = ({ arr }) => {
  let level2Arr = Object.values(arr);

  return level2Arr.map((item, index) => {
    let level2cr = 0;
    let level2dr = 0;
    item.forEach((va) => {
      if (va.amount < 0) {
        level2cr = level2cr + Math.abs(va.amount);
      } else {
        level2dr = level2dr + va.amount;
      }
    });

    return (
      <View>
        <Level3Row arr={item} />
        <View style={styles.invoiceRowCssLevel2} key={index}>
          <Text style={styles.trialLevel2}>
            {item[0].l1}-{item[0].l2}
          </Text>
          <Text style={styles.trialparticularslevel1}>{item[0].l2desc}</Text>
          <Text style={styles.trialtotallevel2}>
            {level2dr - level2cr < 0
              ? Math.abs(level2dr - level2cr).toLocaleString() + " Cr"
              : Math.abs(level2dr - level2cr).toLocaleString() + " Dr"}
          </Text>
          <Text style={styles.trialcredit}>{level2dr.toLocaleString()}</Text>
          <Text style={styles.trialcredit}>{level2cr.toLocaleString()}</Text>
        </View>
      </View>
    );
  });
};
const Level1Row = ({ items }) => {
  let GrandCr = 0;
  let GrandDr = 0;

  let arle = items.map((item, index) => {
    let level1cr = 0;
    let level1dr = 0;
    var newObject = item.reduce(function (obj, value) {
      var key = `${value.l2}`;
      if (obj[key] == null) obj[key] = [];
      if (value.amount < 0) {
        level1cr = level1cr + Math.abs(value.amount);
      } else {
        level1dr = level1dr + value.amount;
      }
      obj[key].push(value);
      return obj;
    }, {});
    GrandCr = GrandCr + Math.abs(level1cr);
    GrandDr = GrandDr + Math.abs(level1dr);
    return (
      <View>
        <Level2Row arr={newObject} />
        <View style={styles.invoiceRowCssLevel1} key={index}>
          <Text style={styles.trial}>{item[0].l1}</Text>
          <Text style={styles.trialparticularslevel1}>{item[0].l1desc}</Text>
          <Text style={styles.trialtotallevel1}>
            {level1dr - level1cr < 0
              ? Math.abs(level1dr - level1cr).toLocaleString() + " Cr"
              : Math.abs(level1dr - level1cr).toLocaleString() + " Dr"}
          </Text>
          <Text style={styles.trialcredit}>{level1dr.toLocaleString()}</Text>
          <Text style={styles.trialcredit}>{level1cr.toLocaleString()}</Text>
        </View>
      </View>
    );
  });
  let finalView = (
    <View>
      {arle}
      <View
        style={{
          marginTop: 14,
          color: "black",
          borderWidth: 3,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: 30,
          marginBottom: 18,
          fontSize: 12,
        }}
      >
        <Text
          style={{
            width: "72%",
            textAlign: "right",

            paddingRight: 3,
          }}
        >
          GRAND TOTAL
        </Text>
        <Text
          style={{
            width: "14%",
            textAlign: "right",

            paddingRight: 3,
          }}
        >
          {GrandDr.toLocaleString()}
        </Text>
        <Text
          style={{
            width: "14%",
            textAlign: "right",

            paddingRight: 3,
          }}
        >
          {GrandCr.toLocaleString()}
        </Text>
      </View>
    </View>
  );
  return finalView;
};
export const TrialTableRow = ({ items }) => {
  return (
    <Fragment>
      <Level1Row items={items} />
    </Fragment>
  );
};

export const CashBookTableRow = ({ items }) => {
  console.log(items);
  const rows = (
    <>
      <View
        style={{ textAlign: "center", flexDirection: "row", marginTop: "40px" }}
      >
        <Text>CASH FLOW DETAIL</Text>
      </View>
      <View style={styles.container}>
        <Text style={styles.cashBookColSmall}>V. No </Text>
        <Text style={styles.cashBookColSmall}>Cheque / Inovice</Text>
        <Text style={styles.cashBookColCode}>Code </Text>
        <Text style={styles.cashBookPar}>Particulars </Text>
        <View style={styles.cashBookRec}>
          <View
            style={{
              flexDirection: "row",
            }}
          >
            <Text>Received</Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={styles.cashBookColSub}>
              <Text>Cash</Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>Bank</Text>
            </View>
            {/* <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
              <Text>Sale</Text>
            </View> */}
            <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
              <Text>Journal</Text>
            </View>
          </View>
        </View>
        <View style={[styles.cashBookRec]}>
          <View
            style={{
              flexDirection: "row",
              textAlign: "center",
              borderWidth: 0,
            }}
          >
            <Text>Payments</Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={styles.cashBookColSub}>
              <Text>Cash</Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>Bank</Text>
            </View>
            {/* <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
              <Text>Sale</Text>
            </View> */}
            <View style={[styles.cashBookColSub]}>
              <Text>Journal</Text>
            </View>
          </View>
        </View>
        <View
          style={[styles.cashBookRec, { width: "6%", borderRightWidth: 0 }]}
        >
          <View
            style={{
              flexDirection: "row",
              textAlign: "center",
              borderWidth: 0,
            }}
          >
            <Text>Sales</Text>
          </View>
        </View>
      </View>
      <View>
        <InvoiceCashBookOpenningBal
          bank={items.headerData.bankOpenningBalance}
          cash={items.headerData.cashOpenningBalance}
        />
      </View>
      <InvoiceCashBookItemsRow items={items} />
    </>
  );
  return <Fragment>{rows}</Fragment>;
};
const InvoiceCashBookOpenningBal = ({ bank, cash }) => {
  const rows = (
    <View
      style={[
        styles.invoiceRowCss,
        { borderWidth: 1, borderTopWidth: 0, marginBottom: 0 },
      ]}
    >
      <Text style={[styles.cashBookColSmall, { borderWidth: 0 }]}> </Text>
      <Text style={[styles.cashBookColSmall, { borderWidth: 0 }]}> </Text>
      <Text style={[styles.cashBookColCode, { borderWidth: 0 }]}> </Text>
      <Text
        style={[
          styles.cashBookPar,
          { color: "red", textAlign: "right", paddingRight: 9 },
        ]}
      >
        OPENING BALANCE
      </Text>
      <View style={styles.cashBookRec}>
        <View style={{ flexDirection: "row" }}>
          <View style={styles.cashBookColSub}>
            <Text>{cash.toLocaleString()}</Text>
          </View>
          <View style={styles.cashBookColSub}>
            <Text>{bank.toLocaleString()}</Text>
          </View>
          {/* <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
            <Text> </Text>
          </View> */}
          <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
            <Text> </Text>
          </View>
        </View>
      </View>
      <View style={[styles.cashBookRec, { borderRightWidth: 0 }]}>
        <View style={{ flexDirection: "row" }}>
          <View style={styles.cashBookColSub}>
            <Text> </Text>
          </View>
          <View style={styles.cashBookColSub}>
            <Text> </Text>
          </View>
          {/* <View style={styles.cashBookColSub}>
            <Text> </Text>
          </View> */}
          <View style={styles.cashBookColSub}>
            <Text> </Text>
          </View>
        </View>
      </View>
      <View
        style={[styles.cashBookRec, { width: "6%", borderRightWidth: 0 }]}
      ></View>
    </View>
  );
  return rows;
};
const InvoiceCashBookItemsRow = ({ items }) => {
  console.log(items);
  //  sort by voucher number
  items.invoice.sort((a, b) => {
    if (a.voucherNumber > b.voucherNumber) {
      return 1;
    }
    if (a.voucherNumber < b.voucherNumber) {
      return -1;
    }
    return 0;
  });
  //  sort by  {item.type}-{item.voucherNumber}
  items.invoice.sort((a, b) => {
    if (a.type  > (b.type)) {
      return 1;
    } else if (a.type  < b.type) {
      return -1;
    } else {
      return 0;
    }
  });
  
  const rows = items.invoice.map((item) => {
    if (item.transactionType === "Credit" && item.type == "SALE") {
      return;
    }
    if (item.transactionType === "Credit" && item.type == "EXPENSE") {
      return;
    }
    if (item.transactionType === "Credit" && item.type == "SUPPLIER") {
      return;
    }

    return (
      <View
        style={[
          styles.invoiceRowCss,
          { borderWidth: 1, borderTopWidth: 0, marginBottom: 0 },
        ]}
      >
        <Text style={styles.cashBookColSmall}>
          {item.type}-{item.voucherNumber}
        </Text>
        <Text style={styles.cashBookColSmall}>{item.cheque} </Text>
        <Text style={styles.cashBookColCode}>{item.code}</Text>
        <Text style={styles.cashBookPar}>
          {/* {items.level3Array.find((data) => data.fullcode === item.code).name} */}
          {item.particular}
        </Text>
        <View style={styles.cashBookRec}>
          <View style={{ flexDirection: "row" }}>
            <View style={styles.cashBookColSub}>
              <Text>
                {item.transactionType === "Debit" &&
                (item.type == "CPV" || item.type == "CRV")
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>
                {item.transactionType === "Debit" &&
                (item.type == "BRV" || item.type == "BPV")
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
            {/* <View style={styles.cashBookColSub}>
            <Text>
              {item.transactionType === 'Debit' &&
              (item.type == 'SALE')
                ? item.amount.toLocaleString()
                : ' '}
            </Text> 
          </View>*/}
            <View style={[styles.cashBookColSub, { borderWidth: 0 }]}>
              <Text>
                {item.transactionType === "Debit" && item.type == "JV"
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
          </View>
        </View>
        <View style={[styles.cashBookRec, { borderRightWidth: 0 }]}>
          <View style={{ flexDirection: "row" }}>
            <View style={styles.cashBookColSub}>
              <Text>
                {item.transactionType === "Credit" &&
                (item.type == "CPV" || item.type == "CRV")
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>
                {" "}
                {item.transactionType === "Credit" &&
                (item.type == "BRV" || item.type == "BPV")
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
            {/* <View style={[styles.cashBookColSub, { borderRightWidth: 0 }]}>
            <Text>
              {item.transactionType === 'Credit' && item.type == 'SALE'
                ? item.amount.toLocaleString()
                : ' '}
            </Text>
          </View> */}
            <View style={[styles.cashBookColSub]}>
              <Text>
                {item.transactionType === "Credit" && item.type == "JV"
                  ? item.amount.toLocaleString()
                  : " "}
              </Text>
            </View>
          </View>
        </View>
        <View
          style={[styles.cashBookRec, { width: "6%", borderRightWidth: 0 }]}
        >
          <View
            style={[
              styles.cashBookColSub,
              { width: "100%", borderRightWidth: 0 },
            ]}
          >
            <Text>
              {item.transactionType === "Debit" && item.type == "SALE"
                ? item.amount.toLocaleString()
                : " "}
            </Text>
          </View>
        </View>
      </View>
    );
  });
  return rows;
};
